module.exports = __webpack_public_path__ + "img/system.5ba6d8fb.svg";